import { EcommerceDependenciesFactory } from "./dependencies.factory";

export const ecommerceEpicDependencies = {

    productService       : EcommerceDependenciesFactory.getProductService(),
    ecommerceOrderService: EcommerceDependenciesFactory.getEcommerceOrderService()

}
